export default __webpack_public_path__ + "static/media/umbrellas-desktop.656bf577.jpg";